import { useEffect, useState } from 'react';

export function useIsTyping<T>(deps: T) {
  const [isTyping, setIsTyping] = useState(false);

  useEffect(() => {
    const debouncedTyping = setTimeout(() => {
      setIsTyping(false);
    }, 500);
    return () => {
      setIsTyping(true);
      clearTimeout(debouncedTyping);
    };
  }, [deps]);

  return isTyping;
}
